export class ExecutionFocusVisitRule {
  constructor (raw) {
    this.ruleTypeId = raw.rule_type_id
    this.value = raw.value
    this.comment = raw.comment
    this.photoUrl = raw.photo_url
  }
}

export default class ExecutionFocusVisitDetail {
  constructor (raw) {
    this.visitId = raw.visit_id
    this.executionFocusId = raw.execution_focus_id
    this.storeId = raw.store_id
    this.productId = raw.product_id
    this.submittedAt = raw.submitted_at
    this.rules = Array.isArray(raw.rules)
      ? raw.rules.map(r => new ExecutionFocusVisitRule(r))
      : []
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/models/ExecutionFocusVisitDetail.js